// Feature-flag wrapper - renders CrewSettings (new UI) or legacy Settings based on CREW_MANAGEMENT_UI flag
import React from 'react';
import flags from 'lib/feature-flags';
import Settings from './Settings';
import CrewSettings from './crew-settings/crew-settings';

const CrewSettingsWrapper = () => {
  if (flags.CREW_MANAGEMENT_UI) return <CrewSettings />;
  return <Settings />;
};

export default CrewSettingsWrapper;
